import { render } from "./TruckInventory.vue?vue&type=template&id=13a2e973&scoped=true"
import script from "./TruckInventory.vue?vue&type=script&lang=js"
export * from "./TruckInventory.vue?vue&type=script&lang=js"

import "./TruckInventory.vue?vue&type=style&index=0&id=13a2e973&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging-logistic.hoornbloommasters.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a2e973"]])

export default __exports__